import { olympiaConfig } from "./data";
import CityPageTemplate from "../city-template/CityPageTemplate";

export default function OlympiaPage() {
  return <CityPageTemplate config={olympiaConfig} />;
}